const formatPrice = (price, prefix = true) => {
  const numberPrice = typeof price !== 'number' ? Number(price) : price;
  const isNegative = numberPrice < 0;
  const prefixChar = prefix ? '$' : '';
  return `${isNegative ? '-' : ''}${prefixChar}${Math.abs(numberPrice).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
};

export default formatPrice;



// WEBPACK FOOTER //
// ./src/utils/formatPrice.js